import { BaseState } from '@/store/base-state';
import { News, NewsFilters } from '../types';
import { default_news } from '../service';

export default class NewsState extends BaseState {
  news: News.News[] = [];
  news_detail: News.News = default_news();
  news_loading = false;
  type_stats = '';

  filters: NewsFilters = {
    search: '',
    dates: [],
    publication_type: [],
  };
}
